import {
  Card,
  LoadingSkeleton,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';

export const LocationsLoading = () => {
  return (
    <div className="locations-loading">
      {[...Array(12)].map((_, i) => (
        <Card type="primary" width={300} key={i}>
          <LoadingSkeleton lines={3} width="100%" isLoading={true} />
        </Card>
      ))}
    </div>
  );
};
